// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.comp-security__sections-wrapper .info-section__title {\n  font-size: 13px;\n}\n.comp-security__sections-wrapper .info-section__text {\n  font-size: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
